import React from "react";

import { Dialog } from "@tiny/components";
import AudienceSummary from "../AudienceSummary/AudienceSummary";

export interface AudienceSummaryDialogProps {
  open: boolean;
  onClose: () => void;
  segmentIds: string[];
}

function AudienceSummaryDialog(props: AudienceSummaryDialogProps) {
  const { open, onClose, segmentIds } = props;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <AudienceSummary
        segmentIds={segmentIds}
        noBorderRadius
        onClose={onClose}
      />
    </Dialog>
  );
}

export default AudienceSummaryDialog;
